import React from 'react';
import styles from './ModalOverlay.module.scss';

const ModalOverlay = ({onClick, children}) => {

    return(
        <section  className={styles.popup} onClick={onClick} >
            {children}
        </section>
    
    );
};

export default ModalOverlay